module.controller('profileSidebarCtrl', ['$scope', function ($scope) {
  // Small controller to avoid repetition in app.js
  $scope.title = 'Hey friend';
  $scope.info = 'It\'s always good to keep your address updated on your ' +
    $scope.brand.commonProgramName + '. If you move, please log in and update your address here.';
}]);
